// src/components/register/RegistrationWizard/Steps/BasicDetailsStep.js
import React, { useState } from "react";
import { useRegistration } from "../../../../context/RegistrationContext";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import InputField from "../../../Usables/InputField";
import { toast } from "react-toastify";
import axios from "../../../../api/axios";
import OpguruLogo from "../../../../assets/opgurulogo.png";
import { TailSpin } from "react-loader-spinner";

const BasicDetailsStep = () => {
  const {
    name,
    email,
    phno,
    setField,
    nextStep,
    validateStep,
    generateUserId,
    formErrors,
  } = useRegistration();

  const [loading, setLoading] = useState(false);
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [emailToken, setEmailToken] = useState("");

  const SEND_MAIL_ROUTE = "/api/emailtokenmailer";
  const VERIFY_TOKEN_ROUTE = "/api/emailtokenverify";

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setField(name, value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate fields
    if (!validateStep(1)) {
      toast.error("Please fill all the required fields correctly", {
        position: "top-center",
      });
      return;
    }

    try {
      // Send email token
      await axios.post(SEND_MAIL_ROUTE, {
        name,
        email,
      });
      
      // Generate and save userID
      const userId = generateUserId(name);
      setField('generatedUserId', userId);
      
      setShowOtpForm(true);
      toast.success("Email verification code sent successfully!", {
        position: "top-center",
      });
    } catch (err) {
      toast.error(err.response?.data?.message || "Error sending verification code", {
        position: "top-center",
      });
    }
  };

  const verifyEmailToken = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const res = await axios.post(VERIFY_TOKEN_ROUTE, {
        email,
        emailToken,
      });
      
      toast.success("Email verified successfully!", {
        position: "top-center",
      });
      
      // Set email as verified and proceed to next step
      setField('isEmailVerified', true);
      nextStep();
    } catch (err) {
      toast.error(err.response?.data?.message || "Invalid verification code", {
        position: "top-center",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="step-container">
      <div className="auth-header">
        <div className="auth-title">Sign Up</div>
        <div className="auth-logo">
          <img src={OpguruLogo} alt="OpGuru Logo" />
        </div>
      </div>
      
      <div className="welcome-message">
        Please enter your details to get started.
      </div>

      {!showOtpForm ? (
        <form onSubmit={handleSubmit} className="registration-form">
          <div className="input-group">
            <InputField
              type="text"
              value={name}
              placeholder="Full Name"
              name="name"
              onChange={handleChange}
              error={formErrors.name}
            />
          </div>
          
          <div className="input-group">
            <PhoneInput
              defaultCountry="IN"
              value={phno}
              onChange={(value) => setField('phno', value)}
              placeholder="Enter Phone Number"
              required
              className={formErrors.phno ? "error-input" : ""}
            />
            {formErrors.phno && <div className="error-message">{formErrors.phno}</div>}
          </div>
          
          <div className="input-group">
            <InputField
              type="email"
              value={email}
              placeholder="Email"
              name="email"
              onChange={handleChange}
              error={formErrors.email}
            />
          </div>

          <div className="terms-conditions">
            By signing up, you are agreeing to our{" "}
            <span className="terms-link">Terms And Conditions.</span>
          </div>

          <button
            type="submit"
            className="primary-button"
          >
            {loading ? (
              <TailSpin
                visible={true}
                height="24"
                width="24"
                color="#ffffff"
                ariaLabel="tail-spin-loading"
                radius="1"
              />
            ) : (
              "Next"
            )}
          </button>
        </form>
      ) : (
        <div className="otp-verification">
          <div className="otp-message">Email Verification</div>
          <div className="otp-instructions">
            We have sent a verification code to <strong>{email}</strong>
          </div>
          
          <form onSubmit={verifyEmailToken} className="registration-form">
            <div className="input-group">
              <input
                type="text"
                placeholder="Enter Verification Code"
                value={emailToken}
                onChange={(e) => setEmailToken(e.target.value)}
                className="form-control"
              />
            </div>
            
            <button type="submit" className="primary-button" disabled={loading}>
              {loading ? (
                <TailSpin
                  visible={true}
                  height="24"
                  width="24"
                  color="#ffffff"
                  ariaLabel="tail-spin-loading"
                  radius="1"
                />
              ) : (
                "Verify"
              )}
            </button>
          </form>
        </div>
      )}

      <div className="login-link">
        Already have an account? <a href="/login">Login</a>
      </div>
    </div>
  );
};

export default BasicDetailsStep;